import React, { useEffect, useRef } from 'react';
import Typography from '@material-ui/core/Typography';
import InputBase from '@material-ui/core/InputBase';
import { fade, makeStyles } from '@material-ui/core/styles';
import SearchIcon from '@material-ui/icons/Search';
// import List from '@material-ui/core/List';
// import ListItem from '@material-ui/core/ListItem';
// import ListItemText from '@material-ui/core/ListItemText';
import Box from '@material-ui/core/Box';
import { Link } from 'gatsby';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import Card from '@material-ui/core/card';
import CardContent from '@material-ui/core/CardContent';
import * as JsSearch from 'js-search';
import { VariableSizeList } from 'react-window';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

import { groupBy, map, flatten, sortBy, toArray } from 'lodash';

const useStyles = makeStyles(theme => ({
  search: {
    position: 'relative',
    flexGrow: 1,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    height: theme.spacing(7),
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto',
    },
  },
  searchIcon: {
    width: theme.spacing(7),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
    width: '100%',
    height: theme.spacing(7),
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 7),
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: 200,
    },
  },
  cardContent: {
    // "&::after": {
    //   content: '" "',
    //   width: "0px",
    //   height: "0px",
    //   borderTop: "20px solid transparent",
    //   borderLeft: "20px solid transparent",
    //   borderBottom: "20px solid #424242",
    //   borderRight: "20px solid transparent",
    //   position: "absolute",
    //   left: "30%",
    //   top: "19.5%",
    //   marginLeft: "-10px",
    // },
  },
  title: {
    fontWeight: 900,
    textTransform: `uppercase`,
    borderBottom: `2px solid grey`,
    marginBottom: `10px`,
  },
  link: {
    color: `#fff`,
    boxShadow: `none`,
    '&:hover': {
      textDecoration: 'underline',
      color: `#D3D3D3`,
    },
  },
}));

/**
 * Be careful using this hook. It only works because the number of
 * breakpoints in theme is static. It will break once you change the number of
 * breakpoints. See https://reactjs.org/docs/hooks-rules.html#only-call-hooks-at-the-top-level
 */
function useWidth() {
  const theme = useTheme();
  const keys = [...theme.breakpoints.keys].reverse();
  return (
    keys.reduce((output, key) => {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const matches = useMediaQuery(theme.breakpoints.up(key));
      return !output && matches ? key : output;
    }, null) || 'xs'
  );
}

export default function SecondaryHome({ songs }) {
  const listRef = useRef();
  const width = useWidth();
  const [widthInt, setWidthInt] = React.useState(1200);

  const [search, setSearch] = React.useState('');
  const [songsArray, setSongsArray] = React.useState([]);

  useEffect(() => {
    const dataToSearch = new JsSearch.Search('slug');
    /**
    //  *  defines a indexing strategy for the data
    //  * more more about it in here https://github.com/bvaughn/js-search#configuring-the-index-strategy
    //  */
    // dataToSearch.indexStrategy = new JsSearch.PrefixIndexStrategy()
    // /**
    //  * defines the sanitizer for the search
    //  * to prevent some of the words from being excluded
    //  *
    //  */
    // dataToSearch.sanitizer = new JsSearch.LowerCaseSanitizer()
    // /**
    //  * defines the search index
    //  * read more in here https://github.com/bvaughn/js-search#configuring-the-search-index
    //  */
    // dataToSearch.searchIndex = new JsSearch.TfIdfSearchIndex("id")
    dataToSearch.addIndex('artist'); // sets the index attribute for the data
    dataToSearch.addIndex('title');
    dataToSearch.addIndex('excerpt');

    let transformedSongs = map(songs, (song, index) => {
      return {
        id: index,
        title: song.node.frontmatter.title,
        artist: song.node.frontmatter.artist,
        excerpt: song.node.excerpt,
        slug: song.node.fields.slug,
      };
    });
    let songsArray = toArray(groupBy(transformedSongs, 'artist'));
    dataToSearch.addDocuments(flatten(songsArray));
    setSongsArray(songsArray);
    setSearch(dataToSearch);
  }, [songs]);

  useEffect(() => {
    switch (width) {
      case 'md':
        setWidthInt(900);
        break;
      case 'sm':
        setWidthInt(550);
        break;
      case 'xs':
        setWidthInt(300);
        break;
      default:
        setWidthInt(1200);
        break;
    }
    listRef.current.resetAfterIndex(0);
  }, [width]);

  const [searchQueryObj, setSearchQuery] = React.useState('');

  const handleSubmit = e => {
    e.preventDefault();
  };

  const onChange = e => {
    const queryResult = search.search(e.target.value);
    setSearchQuery({
      searchQuery: e.target.value,
      searchResults: groupBy(queryResult, 'artist'),
    });
    listRef.current.resetAfterIndex(0);
  };

  const filteredList = searchQueryObj.searchQuery
    ? searchQueryObj.searchResults
    : songsArray;

  const songsList = sortBy(
    filteredList,
    artistCollection => artistCollection[0].artist
  );

  const classes = useStyles();

  const getItemHeight = index => {
    if (width === 'xs') {
      return 45 + Math.round(songsList[index].length) * 30;
    } else {
      return 45 + Math.round(songsList[index].length / 2) * 30;
    }
  };

  const Row = ({ index, style }) => (
    <Container style={style} key={index}>
      <Typography variant="body1" component="h1" className={classes.title}>
        {songsList[index][0].artist}
      </Typography>
      <Grid container spacing={0}>
        {songsList[index].map((song, index) => (
          <Grid
            item
            xs={12}
            sm={6}
            key={index}
            style={{
              marginBottom: 5,
            }}
          >
            {/* <ListItem
                style={{
                  boxShadow: `none`,
                }}
                button
                component={Link}
                to={song.slug}
              >
                <ListItemText primary={song.title} />
              </ListItem> */}
            <li style={{ marginBottom: `5px` }}>
              <Link className={classes.link} to={song.slug}>
                {song.title}
              </Link>
            </li>
          </Grid>
        ))}
      </Grid>
    </Container>
  );

  return (
    <React.Fragment>
      <Container maxWidth="md">
        <Box my={3}>
          <form onSubmit={handleSubmit}>
            <div className={classes.search}>
              <div className={classes.searchIcon}>
                <SearchIcon />
              </div>
              <InputBase
                placeholder="Search…"
                classes={{
                  root: classes.inputRoot,
                  input: classes.inputInput,
                }}
                inputProps={{ 'aria-label': 'search' }}
                onChange={onChange}
              />
            </div>
          </form>
        </Box>
      </Container>
      <Container maxWidth="lg">
        <Card classes={{ root: classes.cardContent }}>
          <CardContent>
            <VariableSizeList
              // className="List"
              ref={listRef}
              height={450}
              itemCount={songsList.length}
              itemSize={getItemHeight}
              width={widthInt}
            >
              {Row}
            </VariableSizeList>
          </CardContent>
        </Card>
      </Container>
    </React.Fragment>
  );
}
